import * as E from 'io-ts/Encoder';

export const StringToNumber: E.Encoder<number, string> = {
    encode: Number, // TODO NaN обработать
};
